<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button variant="success" class="btn-icon" v-b-tooltip v-bind:title="$t('operations.add')" @click="onWhitelistSelected(null)">
          <i class="fa-solid fa-shield-virus"></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>
    <!--Filters-->
    <filter-card  v-model="filter" v-bind:fields="filterFields" search/>
    <!--Table Card-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{$t("menu.whitelists")}}</h5>
      </b-card-header>
      <b-card-body>
        <whitelists-table ref="whitelistTable" v-bind:filters="filter" v-bind:columns="columns" :has-selection="false" @selected="onWhitelistSelected" :lazy="true"/>
      </b-card-body>
    </b-card>
    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="whitelists" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <whitelist-modal ref="whitelist-modal" />
  </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import WhitelistSearchRequest from '@/model/whitelist/WhitelistSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Whitelist from '@/model/whitelist/Whitelist'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import WhitelistModal from '@/components/modal/whitelistModal'
import FilterCard from '@/components/widget/FilterCard'
import WhitelistFilterFields from '@/model/filter/WhitelistFilterFields'
import WhitelistsTable from '@/components/tables/WhitelistsTable'

export default {
  name: 'WhitelistsView',
  components: {WhitelistsTable, FilterCard, WhitelistModal, ColumnsModal, BreadcrumbButton },
  mixins: [mixinBase,mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Whitelist()),
      filter: WhitelistSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = WhitelistFilterFields();
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('whitelist', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onWhitelistSelected(selectedId) {
      this.$refs['whitelist-modal'].showModal(selectedId)
    },
  }
}
</script>

<style>
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
  height: 10px;
}
</style>
